import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

export const PriceChip = ({ children, size = 'small' }: { children: ReactNode; size?: 'small' | 'large' }) => {
  return (
    <Box
      sx={{
        borderRadius: '8px',
        backgroundColor: '#F7F5FF',
        px: size === 'small' ? 1 : 2,
        py: size === 'small' ? 0.5 : 1,
        textAlign: 'center',
      }}
    >
      <Typography
        variant={size === 'small' ? 'body1' : 'h5'}
        sx={{
          fontWeight: 'bold',
          margin: '0 auto',
        }}
      >
        {children}
      </Typography>
    </Box>
  );
};
